import { Div, useColorSchemeValue } from "@hopper-ui/components";
import { HomeAnimatedBackground } from "@sg-protect/components";
import { partnerTierBackgroundColors } from "./partnerTierBackgroundColors.ts";
import { PartnerLayout, type PartnerLayoutProps } from "./PartnerLayout.tsx";
import { usePartnerTier } from "./usePartnerTier.ts";

export type PartnerDashboardLayoutProps = PartnerLayoutProps;

export const PartnerDashboardLayout = (props: PartnerDashboardLayoutProps) => {
    const partnerTier = usePartnerTier();
    const backgroundGradient = useColorSchemeValue(
        partnerTier ? partnerTierBackgroundColors[partnerTier].light : "",
        partnerTier ? partnerTierBackgroundColors[partnerTier].dark : ""
    );

    return (
        <>
            {partnerTier && (
                <Div
                    zIndex={-1}
                    position="fixed"
                    top={0}
                    left={0}
                    UNSAFE_width="100vw"
                    UNSAFE_height="100vh"
                    backgroundImage={backgroundGradient}
                />
            )}
            <HomeAnimatedBackground />
            <PartnerLayout {...props} />
        </>
    );
};
